module.exports = __webpack_public_path__ + "img/HappyPhoto38.8af531ad.jpeg";